// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"633":"7ca04c38","880":"9f494a1d"}[chunkId] + ".css";
};